module.exports = __webpack_public_path__ + "static/media/grayPancakeIcon.bcbd62ef.svg";